import script from "./MyMatchInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MyMatchInfo.vue?vue&type=script&setup=true&lang=js"

import "./MyMatchInfo.vue?vue&type=style&index=0&id=b3fac8d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3fac8d8"]])

export default __exports__